export default "__VITE_ASSET__BQ_wsaPt__"